/**
 * Format a number with Indian comma style (lakhs, crores)
 * e.g., 1234567 → "12,34,567"
 */
export const formatIndianNumber = (value) => {
  if (value === '' || value === null || value === undefined) return '';
  const num = String(value).replace(/,/g, '');
  if (isNaN(num) || num === '') return String(value);
  
  // Handle decimal part
  const parts = num.split('.');
  let intPart = parts[0];
  const decPart = parts.length > 1 ? '.' + parts[1] : '';
  
  // Handle negative
  const isNeg = intPart.startsWith('-');
  if (isNeg) intPart = intPart.slice(1);
  
  if (intPart.length <= 3) return (isNeg ? '-' : '') + intPart + decPart;
  
  // Indian grouping: last 3, then groups of 2
  let result = intPart.slice(-3);
  let remaining = intPart.slice(0, -3);
  while (remaining.length > 2) {
    result = remaining.slice(-2) + ',' + result;
    remaining = remaining.slice(0, -2);
  }
  if (remaining.length > 0) {
    result = remaining + ',' + result;
  }
  
  return (isNeg ? '-' : '') + result + decPart;
};

/**
 * Strip commas from formatted number for storing raw value
 */
export const stripCommas = (value) => {
  if (typeof value !== 'string') return value;
  return value.replace(/,/g, '');
};
